import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { CustomerCertificationModalComponent } from './customer-certification-modal.component';
import { CustomerCertificationComponent } from './customer-certification.component';

@NgModule({
    declarations: [
        CustomerCertificationComponent,
        CustomerCertificationModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        CommonModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedPipesModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerCertificationComponent,
        CustomerCertificationModalComponent
    ]
})

export class CustomerCertificationModule { }
